import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

const MetaTags = ({ title, description, url }) => {
  // Skip rendering if URL is empty
  if (!url) {
    return null;
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};

// Default props
MetaTags.defaultProps = {
  title: "פינתי",
  description: "פינת הקוד של נתי",
  url: "",
};

// Prop types for validation
MetaTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string.isRequired,
};

export default MetaTags;
